import { api } from './api';

interface ReconhecaAccessRequest {
  ssoToken: string;
  active: boolean;
}

function generateSecureUuidV4(): string {
  if (typeof crypto.randomUUID === 'function') {
    return crypto.randomUUID();
  }

  // Fallback for browsers without crypto.randomUUID: still uses a
  // cryptographically secure source (crypto.getRandomValues), never Math.random().
  const bytes = crypto.getRandomValues(new Uint8Array(16));
  bytes[6] = (bytes[6] & 0x0f) | 0x40;
  bytes[8] = (bytes[8] & 0x3f) | 0x80;

  const hex = Array.from(bytes, (byte) => byte.toString(16).padStart(2, '0'));
  return [
    hex.slice(0, 4).join(''),
    hex.slice(4, 6).join(''),
    hex.slice(6, 8).join(''),
    hex.slice(8, 10).join(''),
    hex.slice(10, 16).join(''),
  ].join('-');
}

export async function requestReconhecaAccess(): Promise<ReconhecaAccessRequest> {
  const ssoToken = generateSecureUuidV4();

  // PUT (not POST) so the brb_sso_token__c before_update trigger runs: it
  // stamps the authenticated player, blocks brb_blocklist__c entries and sets expireAt.
  const response = await api.put('/database/brb_sso_token__c', { _id: ssoToken });

  return {
    ssoToken,
    active: Boolean(response.data?.active),
  };
}
